import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useAutoSync } from "./hooks/useAutoSync";
import { useEffect } from "react";

// Composant pour gérer le scroll en haut de page
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Composant wrapper qui contient ScrollToTop et AppRoutes
function AppContent() {
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
    </>
  );
}

function App() {
  // Synchronisation automatique globale toutes les 5 minutes
  useAutoSync(5);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppContent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
